/**
 * @name credit-card-reader
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTZ2MSIgLz4KICA8cGF0aCBkPSJNMTYuOTYzIDcuNzM0QTEgMSAwIDAwMTUuOTk5IDdIOC4wMDNhMSAxIDAgMDAtLjk2NC43MzRMNC4wNzMgMTguNDY3QTIgMiAwIDAwNiAyMWgxMmEyIDIgMCAwMDEuOTI3LTIuNTMyeiIgLz4KICA8cGF0aCBkPSJNMi42NzggOC41QTIgMiAwIDAxMiA3VjVhMiAyIDAgMDEyLTJoMTZhMiAyIDAgMDEyIDJ2MmEyIDIgMCAwMS0uNjc2IDEuNDk5IiAvPgogIDxwYXRoIGQ9Im05IDIxIDItMTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/credit-card-reader
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const CreditCardReader: string = `
<svg
  class="lucide lucide-credit-card-reader"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M15 16v1" />
  <path d="M16.963 7.734A1 1 0 0015.999 7H8.003a1 1 0 00-.964.734L4.073 18.467A2 2 0 006 21h12a2 2 0 001.927-2.532z" />
  <path d="M2.678 8.5A2 2 0 012 7V5a2 2 0 012-2h16a2 2 0 012 2v2a2 2 0 01-.676 1.499" />
  <path d="m9 21 2-14" />
</svg>
`;

export default CreditCardReader;
